import { render, staticRenderFns } from "./ModifyAvatar.vue?vue&type=template&id=3f1c32e3&scoped=true"
import script from "./ModifyAvatar.vue?vue&type=script&lang=ts"
export * from "./ModifyAvatar.vue?vue&type=script&lang=ts"
import style0 from "./ModifyAvatar.vue?vue&type=style&index=0&id=3f1c32e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1c32e3",
  null
  
)

export default component.exports